export default {
  DEFAULT: "100%",
  XS: "115%",
  SM: "120%",
  MD: "133%",
  LG: "150%",
  XL: "170%",
  XXL: "200%"
};
